
    <h1>{{ orgCampaignDetails.Description }}</h1>
      <h2 (click)="goToNextPage()">Thank you! Your ${{ campaignProfile.ContributionAmount }} payment
        was successful!</h2>
